<template>
  <div>
    <v-layout row v-for="number in currentQuestion.data.sortCount" :key="number">
      <v-select
        v-bind:items="currentQuestion.data.choices"
        v-model="answers[number]"
        :label="`Mon choix N°${number}`"
        single-line
        bottom
        @change="selectChanged(number, $event)"
      ></v-select>
    </v-layout>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import _ from 'lodash';

  export default {
    name: "Order",
    data: () => ({
      answers: {},
    }),
    computed: {
      ...mapState([
        `currentQuestion`,
      ]),
    },
    methods: {
      clear () {
        this.answers = {};
      },
      selectChanged (num, event) {
        this.answers[num] = event;
        let sameAnswer = _.findKey(this.answers, (answer, key) => {
          return answer === event && Number(key) !== Number(num);
        });
        if (sameAnswer) {
          this.answers[sameAnswer] = null;
        }
        this.$forceUpdate();
        let valid = this.currentQuestion.data.sortCount === Object.values(this.answers).length;
        if (valid) {
          for (const answer of Object.values(this.answers)) {
            valid &= Boolean(answer);
          }
        }
        this.$emit(`canValidate`, valid);
        this.$emit(`newAnswer`, _.map(this.answers, (answer, key) => `Choix ${key} : ${answer}`).join(`, `));
      },
    },
  };
</script>

<style>
  .input-group--text-field {
    border: rgba(0,0,0,.87) 2px solid;
    padding: 1.4rem 1rem 0 1rem;
  }

  .input-group--text-field label {
    left: 1rem;
    top: 1.3rem;
  }

  .input-group__details::before {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// Order.vue?9f586eae